import alertTokens from '@amzn/meridian-tokens/component/alert';
import buttonTokens from '@amzn/meridian-tokens/component/button';
import expanderTokens from '@amzn/meridian-tokens/component/expander';
import formFieldWrapperTokens from '@amzn/meridian-tokens/component/form-field-wrapper';
import inputTokens from '@amzn/meridian-tokens/component/input';
import loaderTokens from '@amzn/meridian-tokens/component/loader';
import mastheadTokens from '@amzn/meridian-tokens/component/masthead';
import modalTokens from '@amzn/meridian-tokens/component/modal';
import optionListTokens from '@amzn/meridian-tokens/component/option-list';
import tabTokens from '@amzn/meridian-tokens/component/tab';
import textTokens from '@amzn/meridian-tokens/component/text';
/*
 * Amazon Ember Modern typography as Meridian theme tokens, for the
 * WEBLAB_PAINTER_FONT_MODERNIZATION T1 arm (App.tsx passes them to App's <Theme>).
 *
 * Meridian styles text with typographyCss(key), which reads the `<key>FontFamily` theme token
 * and only falls back to its hardcoded Amazon Ember when that token is undefined. Every such key
 * has a matching `<key>FontSize` token, so one FontFamily token is derived per FontSize token:
 * Display at 18px and above, Text below. Size, weight and line-height tokens are not touched.
 *
 * Meridian's Text (and Heading) only reads `textDefaultFontFamily`: its `type` swaps size, weight
 * and line-height but not the family, so the derived textH200+ / textB400+ tokens are unused
 * today and every Text renders Modern Text. Display reaches Meridian's own large sizes that do
 * read their key (buttonLabelLarge/Xlarge, alertTitleXlarge); large Text gets Display only when
 * tagged data-font="display".
 *
 * The Text value reads --emt-face first, so an element tagged data-font="display" (see
 * emberModernBase.scss) swaps to Display by setting a custom property, not by out-ranking a
 * Meridian selector.
 */
const FALLBACK = "'Amazon Ember', 'Amazon Ember Arabic', Arial, sans-serif";
export const EMBER_MODERN_TEXT = `var(--emt-face, 'Amazon Ember Modern Text'), ${FALLBACK}`;
export const EMBER_MODERN_DISPLAY = `'Amazon Ember Modern Display', ${FALLBACK}`;
const DISPLAY_MIN_PX = 18;
// The Meridian components the app renders text through (expander via the EU compliance widget).
// Their token factories reference theme colours, but font sizes are literals, so no theme is needed.
const componentTokenSets = [
    alertTokens,
    buttonTokens,
    expanderTokens,
    formFieldWrapperTokens,
    inputTokens,
    loaderTokens,
    mastheadTokens,
    modalTokens,
    optionListTokens,
    tabTokens,
    textTokens,
].map((factory) => factory({}));
export const emberModernTokens = Object.fromEntries(componentTokenSets.flatMap((tokens) => Object.entries(tokens)
    .filter(([key, value]) => key.endsWith('FontSize') && typeof value === 'number')
    .map(([key, size]) => [
    key.replace(/FontSize$/, 'FontFamily'),
    size >= DISPLAY_MIN_PX ? EMBER_MODERN_DISPLAY : EMBER_MODERN_TEXT,
])));
